import React, { useState,useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "../../utils/apiEndpoints";

const AddUser = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("admin");
    const [responseMessage, setResponseMessage] = useState(null);
    const [errorData, setErrorData] = useState(null);
    const [addedUser, setAddedUser] = useState(null);
    const [loading, setLoading] = useState(false);

    const [userRole, setUserRole] = useState(null);
    
    const token = localStorage.getItem("adminToken");




    const handleAddUser = async () => {
        if (userRole !== "super_admin") {
            setResponseMessage("Access Denied. Only Super Admins Can Add Users.");
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_ADD_USER,
                { name, email, password, role },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            setResponseMessage(response.data.message);
            setAddedUser(response.data.admin);
            setErrorData(null);
            setName("");
            setEmail("");
            setPassword("");
            setRole("admin");
        } catch (error) {
            if (error.response && error.response.data) {
                setResponseMessage(error.response.data.message);
                setErrorData(error.response.data.data || null);
            } else {
                setResponseMessage("An error occurred. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };
    
    
    useEffect(() => {
        const storedRole = localStorage.getItem("adminRole"); // Assuming it's stored as a plain string
        // console.log(storedRole, "SUUUU"); // Debugging output
        if (storedRole) {
            setUserRole(storedRole); // Directly set the role
        }
    }, []);   

    return (
        <div className="w-screen min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
            <div className="relative py-3 sm:max-w-md sm:mx-auto">
                <div className="min-h-96 px-10 py-6 mt-4 text-left bg-white rounded-xl shadow-lg">
                    <h2 className="text-center font-semibold text-lg">Add New User</h2>
                    
                    {/* {responseMessage && !errorData && (
    <p className="text-center text-green-500 mt-2">{responseMessage}</p>
)} */}
{responseMessage && !errorData &&  (
    <p className={`text-center mt-2 ${responseMessage.includes("Access Denied") ? "text-red-500" : "text-green-500"}`}>
        {responseMessage}
    </p>
)}

{errorData && (
    <div className="text-red-500 text-xs mt-2">
        {Object.entries(errorData).map(([field, errors]) => (
            <p key={field}>{errors[0]}</p>
        ))}
    </div>
)}

                    <div className="w-full flex flex-col gap-2 mt-4">
                        <label className="font-semibold text-xs text-gray-400">Name</label>
                        <input
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            type="text"
                            placeholder="Enter Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />

                        <label className="font-semibold text-xs text-gray-400">Email</label>
                        <input
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            type="email"
                            placeholder="Enter Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <label className="font-semibold text-xs text-gray-400">Password</label>
                        <input
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            type="password"
                            placeholder="Enter Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        <label className="font-semibold text-xs text-gray-400">Role</label>
                        <select
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="admin">Admin</option>
                        </select>

                        <button
    onClick={handleAddUser}
    className="py-1 px-8 bg-blue-500 hover:bg-blue-800 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md rounded-lg cursor-pointer flex items-center justify-center"
    disabled={loading}
>
    {loading ? "Loading..." : "Add User"}
</button>


                        {addedUser && (
                            <div className="mt-4 p-3 bg-gray-100 rounded-lg text-sm">
                                <h3 className="font-semibold text-gray-700 mb-2">User Added Successfully:</h3>
                                <p><strong>Name:</strong> {addedUser.name}</p>
                                <p><strong>Email:</strong> {addedUser.email}</p>
                                <p><strong>Role:</strong> {addedUser.role}</p>
                            </div>
                        )}


                        {responseMessage && (
                            <button
                                onClick={() => window.history.back()}
                                className="mt-4 py-1 px-8 bg-gray-500 hover:bg-gray-700 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md rounded-lg cursor-pointer"
                            >
                                Go Back
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUser;
